export default {
    getGroupStatus: { method: 'get', url: 'groups/status' },
    postGroupStatus: { method: 'post', url: 'groups/status' },
    updateGroupStatus: { method: 'put', url: 'groups/status/{id}' },
    deleteGroupStatus: { method: 'delete', url: 'groups/status/{id}' },
}